import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Transliteration from "./Transliteration";
import DatePicker from "react-datepicker";
import moment from "moment";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import googleTransliterate from "google-input-tool";
import AddPensionProposalData from "./AddPensionProposalData";
import EditPensionProposalData from "./EditPensionProposalData";

const PensionProposal = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const userId = localStorage.getItem("userId");
  const [query, setQuery] = useState("");
  const [PPEditId, setPPEditId] = useState("");
  // const navigate = useNavigate();

  const [filterPPData, setFilterPPData] = useState([]);
  const [PensionProposalData, setPensionProposalData] = useState([]);
  const getPensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        setPensionProposalData(result.result);
        setFilterPPData(result.result);
      } else {
        setPensionProposalData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getPensionProposalData();
  }, [userId, openDialog]);

  const handleFilterData = (query) => {
    const lowerCaseQuery = query.toLowerCase();
    const filteredItems = PensionProposalData.filter((admin) => {
      return (
        admin.empName.toLowerCase().includes(lowerCaseQuery) ||
        admin.empDesignation.toLowerCase().includes(lowerCaseQuery) ||
        admin.gpfNumber.toLowerCase().includes(lowerCaseQuery) ||
        admin.officeName.includes(lowerCaseQuery) ||
        admin.appointmentDate.toLowerCase().includes(lowerCaseQuery) ||
        admin.retirementDate.includes(lowerCaseQuery)
      );
    });

    setFilterPPData(filteredItems);
  };

  const editPPData = (Id) => {
    setPPEditId(Id);
    setEditDialog(true);
  };

  return (
    <div className="pension-proposal-data p-6">
      <div className="row">
        <div className=" col-lg-7 text-left"></div>
        <div className=" col-lg-3 col-7 text-left">
          <div className="input-group mb-3">
            <span className="input-group-text" id="basic-addon1">
              <i className="fas fa-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Employee Search Here..."
              value={query}
              onChange={(e) => {
                setQuery(e.target.value);
                handleFilterData(e.target.value);
              }}
            />
          </div>
        </div>
        <div className=" col-lg-2 col-3 text-end">
          <Link
            className="btn btn-primary w-100"
            to="#"
            onClick={() => setOpenDialog(!openDialog)}
          >
            Add New
          </Link>
        </div>
      </div>
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="pills-home-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-home"
            type="button"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
          >
            Pension All Data
          </button>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-home"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="table-responsive  overflow-x-auto">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Office Name</th>
                      <th scope="col">Designation</th>
                      <th scope="col">GPF No.</th>
                      <th scope="col">Appointment Date</th>
                      <th scope="col">Retirement Date</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterPPData &&
                      filterPPData.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item.empName}</td>
                            <td>{item.officeName}</td>
                            <td>{item.empDesignation}</td>
                            <td>{item.gpfNumber}</td>
                            <td>{item.appointmentDate}</td>
                            <td>{item.retirementDate}</td>

                            <td>
                              <Link
                                onClick={() => editPPData(item._id)}
                                className="btn btn-primary btn-sm m-1"
                              >
                                <i className="fa fa-edit"></i>{" "}Edit
                              </Link>
                              <Link
                                to={`/dashboard/print_pension_proposal_table/${item._id}`}
                                className="btn btn-success   btn-sm m-1"
                              >
                                <i className="fa fa-print"></i>{" "}
                                <small>Pension Proposal</small>
                              </Link>
                              <Link
                                to={`/dashboard/print_gpf_final_table/${item._id}`}
                                className="btn btn-success   btn-sm m-1"
                              >
                                <i className="fa fa-print"></i>{" "}
                                <small>GPF Final</small>
                              </Link>
                              <Link
                                to={`/dashboard/print_gis_final_table/${item._id}`}
                                className="btn btn-success   btn-sm m-1"
                              >
                                <i className="fa fa-print"></i>{" "}
                                <small>GIS Proposal</small>
                              </Link>
                              <Link
                                to={`/dashboard/print_leave_encashment/${item._id}`}
                                className="btn btn-success   btn-sm m-1"
                              >
                                <i className="fa fa-print"></i>{" "}
                                <small>Leave Encashment</small>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={openDialog}
        onClose={setOpenDialog}
        className="relative z-60 w-100 pension_proposal"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className=" fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="w-50 w-responsive relative transform p-0 overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <AddPensionProposalData setOpenDialog={setOpenDialog} />
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={editDialog}
        onClose={setEditDialog}
        className="relative z-60 w-100 pension_proposal"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className=" fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="w-75 w-responsive relative transform p-0 overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <EditPensionProposalData
                PPEditId={PPEditId}
                setEditDialog={setEditDialog}
              />
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default PensionProposal;
